var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.honor)?_c('div',{staticClass:"c-author-honor",style:({ backgroundImage: `url(${_vm.imgUrl()})` })},[(!_vm.isJdt)?_c('span',{style:({ color: _vm.honor.color })},[_vm._v(_vm._s(_vm.honor.honor))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }